<template>
  <v-row class="pb-4">
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>
    <v-row no-gutters class="pr-4">
      <v-col>
        <v-toolbar flat class="sub-toolbar" height="50px">
          <v-toolbar-title class="primary--text">Currencies</v-toolbar-title>
          <div class="pl-4">
            <v-btn small outlined color="primary" @click="onNewItem">
              <v-icon>add</v-icon>
            </v-btn>
          </div>
        </v-toolbar>
      </v-col>

      <v-col class="d-flex justify-content-end pt-3">
        <v-btn
          small
          color="primary"
          class="font-weight-bold"
          tile
          @click="loadPricingTableForex"
          >LOAD</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-divider></v-divider>
    </v-row>

    <v-row no-gutters>
      <v-col class="px-2">
        <v-card color="white" flat tile>
          <v-data-table
            dense
            :items="currencyPairs"
            :headers="headers"
            no-data-text="Click load to display currencies"
            item-key="cc_id"
          >
            <template v-slot:item="{ item }">
              <tr :key="item.cc_id">
                <td class="service-table-cell">{{ item.cc_id }}</td>
                <td class="service-table-cell">{{ item.base_currency }}</td>
                <td class="service-table-cell">
                  {{ item.conversion_currency }}
                </td>
                <td class="service-table-cell">
                  {{ item.conversion_rate.toFixed(4) }}
                </td>

                <td class="justify-center px-0">
                  <v-menu bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" color="primary" text icon small>
                        <v-icon>menu</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item
                        v-for="(el, i) in menuOptions"
                        :key="i"
                        @click="onMenu(i, item)"
                      >
                        <v-list-item-action class="mr-2">
                          <v-icon size="20" :color="el.color">{{ el.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>{{ el.title }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogUpdateItem" persistent max-width="600px">
      <v-row no-gutters>
        <v-col>
          <v-card color="white" flat tile>
            <v-card-title class="dialog-header-title">{{
              dialogUpdateTitle
            }}</v-card-title>
            <v-alert v-model="alert" :type="alertType" dismissible>{{
              alertMessage
            }}</v-alert>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-row>
                    <v-col cols="6">Base currency:</v-col>
                    <v-col cols="6">
                      <input
                        class="form-control"
                        :disabled="disableOnUpdate"
                        v-model="currency_obj.base_currency"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">Conversion currency:</v-col>
                    <v-col cols="6">
                      <input
                        class="form-control"
                        :disabled="disableOnUpdate"
                        v-model="currency_obj.conversion_currency"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">Conversion rate:</v-col>
                    <v-col cols="6">
                      <input
                        class="form-control"
                        v-model="currency_obj.conversion_rate"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-row justify="end" no-gutters>
                <v-btn
                  @click="updateCurrencyConversion"
                  class="font-weight-bold mr-2"
                  color="primary"
                  tile
                  depressed
                  small
                  >SAVE</v-btn
                >
                <v-btn
                  @click="onCloseDialog"
                  small
                  class="font-weight-bold ml-2"
                  color="error"
                  tile
                  depressed
                  >CLOSE</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
  </v-row>
</template>

<script>
import constant from "@/const";

export default {
  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",
      CONSTANT: constant,

      dialogUpdateItem: false,
      disableOnUpdate: false,
      dialogUpdateTitle: "Add new forex item",

      currency_obj: {
        base_currency: null,
        conversion_currency: null,
        conversion_rate: 0.0,
        cc_id: null,
      },

      currencyPairs: [],

      headers: [
        { text: "ID", value: "cc_id", align: "center", sortable: true },
        {
          text: "Base",
          value: "base_currency",
          align: "center",
          sortable: true,
        },
        {
          text: "Converted",
          value: "conversion_currency",
          align: "center",
          sortable: true,
        },
        {
          text: "Conversion rate",
          value: "conversion_rate",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],

      dataTableRowsItem: [
        10,
        25,
        50,
        { text: "$vuetify.dataFooter.itemsPerPageAll", value: -1 },
      ],
      menuOptions: [
        { title: "Update", icon: "mdi-pencil", color: "primary" },
        { title: "Delete", icon: "mdi-delete", color: "error" },
      ],
    };
  },

  async created() {
    this.$root.blockUImsg = "please wait...";
    this.$root.blockUIshow = true;
    // verify user token
    await this.$root.verify_user_token();

    this.$root.blockUIshow = false;

    // this.loadPricingTableForex()
  },

  mounted() {},

  methods: {
    async loadPricingTableForex() {
      this.$root.blockUImsg = "Loading currencies...";
      this.$root.blockUIshow = true;

      var api_string = "/api/currencies";

      let resp = await this.$https.get(api_string);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.currencyPairs = resp.data.data;
      } else if (resp.data.status == constant.RESPONSE_STATUS_EMPTY) {
        this.currencyPairs = [];
      } else {
        console.log(resp.data);
      }

      this.$root.blockUIshow = false;
    },

    /**
     * Open New Item dialog
     */
    onNewItem() {
      this.resetAlert();
      this.currency_obj = {
        base_currency: null,
        conversion_currency: null,
        conversion_rate: 0.0,
        cc_id: null,
      };
      this.disableOnUpdate = false;
      this.dialogUpdateItem = true;
    },

    /**
     * Open update Item dialog
     */
    async onUpdateItem(item) {
      this.resetAlert();
      this.$root.blockUImsg = "loading...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/currencies/${item.cc_id}`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.currency_obj = resp.data.data;
        // update the title header
        this.dialogUpdateTitle = "Update forex item";
        // disable the base and conversion currency input field
        this.disableOnUpdate = true;
        // open dialog update item
        this.dialogUpdateItem = true;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }
      this.$root.blockUIshow = false;
    },

    /**
     * close dialog and refresh
     */
    onCloseDialog() {
      //close the dialog
      this.dialogUpdateItem = false;

      // refresh table
      this.loadPricingTableForex();
    },

    /**
     * Reset alert to default
     */
    resetAlert() {
      this.alert = false;
      this.alertType = "success";
      this.alertMessage = "";
    },

    /**
     * Add / Update the currency conversion
     */
    async updateCurrencyConversion() {
      // validate form
      if (this.currency_obj.base_currency == null) {
        this.alert = true;
        this.alertType = "warning";
        this.alertMessage = "Base currency cannot be empty";
        return;
      }
      if (this.currency_obj.conversion_currency == null) {
        this.alert = true;
        this.alertType = "warning";
        this.alertMessage = "Conversion currency cannot be empty";
        return;
      }
      if (this.currency_obj.conversion_rate == 0.0) {
        this.alert = true;
        this.alertType = "warning";
        this.alertMessage = "Conversion rate cannot be 0.00";
        return;
      }
      this.$root.msg = "adding new forex item...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.post(`/api/currencies`, this.currency_obj);
      // reset the alert
      this.resetAlert();
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    onMenu(index, item) {
      switch (index) {
        case 0:
          this.onUpdateItem(item);
          break;
        case 1:
          this.deleteCurrencyConversion(item);
          break;
      }
    },

    /**
     * Delete currency conversion
     * @param {object} item
     */
    async deleteCurrencyConversion(item) {
      this.$root.msg = "deleting forex item...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.delete(`/api/currencies/${item.cc_id}`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = `${item.cc_id} forex item deleted`;
        this.loadPricingTableForex();
      } else {
        console.log(resp.data);
      }
      this.$root.blockUIshow = false;
    },
  },

  watch: {},

  computed: {},
};
</script>

<style scoped>
.v-btn-style {
  text-transform: none;
  text-align: left;
  /* font-size: 90%; */
}

.admin-dialog-container {
  padding: 0 30px;
}

.admin-dialog-container .sub-container-row-item {
  padding: 2px 20px;
}

.admin-dialog-container .sub-container-row-item .flex {
  line-height: 2.5;
}

.v-data-table {
  border: 2px solid #e0e0e0;
}
::v-deep .v-data-table thead tr th {
  text-align: center;
  text-transform: none;
  color: black !important;
  font-weight: bold;
  border: 1px;
  padding: 2px 0.2rem;
  height: 20px !important;
  line-height: 30px;
}
</style>
